import { render, staticRenderFns } from "./SNEZFlipPlug.vue?vue&type=template&id=be5446a2"
import script from "./SNEZFlipPlug.vue?vue&type=script&lang=js"
export * from "./SNEZFlipPlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports